import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexColCenter,
  FlexCol,
  FlexRowCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { Loader } from '../../Defaults/Loader';

export interface Props {
  height?: number;
  loaderHeight?: number;
  strokeWidth?: number;
  style?: React.CSSProperties;
  center?: boolean;
  primaryColor?: string;
  secondaryColor?: string;
}

function LoaderWrapper({
  height,
  style,
  loaderHeight,
  strokeWidth,
  center,
  primaryColor,
  secondaryColor,
}: Props) {
  return (
    <Wrapper height={height} center={center}>
      <Loader
        loading={true}
        style={style}
        height={loaderHeight}
        strokeWidth={strokeWidth}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
      />
    </Wrapper>
  );
}

const Wrapper = styled<{ center?: boolean }>(FlexColCenter)`
  width: 100%;
  height: ${({ height }: { height?: number }) =>
    height ? rem(height) : rem(100)};
  margin-right: ${({ center }: { center?: boolean }) =>
    center ? '-5em' : '0'};
  margin-bottom: ${({ center }: { center?: boolean }) =>
    center ? '-5em' : '0'};
`;

export { LoaderWrapper };
